import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined

const CounterList = () => {
    const [counters, setCounters] = useState([]);
    const [filteredCounters, setFilteredCounters] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    // Fetch counters data
    useEffect(() => {
        fetch(`${BASE_URL}counters`)
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    setCounters(data.data || []);
                    setFilteredCounters(data.data || []);
                }
            })
            .catch(error => console.error('Error fetching counters:', error));
    }, []);

    // Search filter
    const handleSearchChange = (event) => {
        const term = event.target.value.toLowerCase();
        setSearchTerm(term);
        const filtered = counters.filter((counter) =>
            counter.counter_no.toLowerCase().includes(term) ||
            counter.warehouse.toLowerCase().includes(term) ||
            counter.patient.toLowerCase().includes(term)
        );
        setFilteredCounters(filtered);
    };

    // Navigate to edit counter page
    const handleEdit = (id) => {
        navigate(`/EditCounter/${id}`);
    };

    // Navigate to add counter page
    const handleAdd = () => {
        navigate('/AddCounter');
    };

    // Handle delete
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this counter?")) {
            fetch(`${BASE_URL}counters/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === "success") {
                        setCounters(counters.filter((counter) => counter.id !== id));
                        setFilteredCounters(filteredCounters.filter((counter) => counter.id !== id));
                        alert("Counter deleted successfully!");
                    } else {
                        alert("Failed to delete counter.");
                    }
                })
                .catch(error => console.error('Error deleting counter:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Counter List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Table Section */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="search" className="form-label">Search</label>
                                        <input
                                            type="text"
                                            id="search"
                                            className="form-control"
                                            placeholder="Search by counter number, warehouse, or patient"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Counter</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>Counter No</th>
                                                <th>Warehouse</th>
                                                <th>Tax Style</th>
                                                <th>Exchange</th>
                                                <th>Patient</th>
                                                <th>Invoice Format</th>
                                                <th>POS Customer</th>
                                                <th>Tender</th>
                                                <th>Created At</th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredCounters.map((counter) => (
                                                <tr key={counter.id}>
                                                    <td>{counter.counter_no}</td>
                                                    <td>{counter.warehouse}</td>
                                                    <td>{counter.tax_style}</td>
                                                    <td>{counter.exchange}</td>
                                                    <td>{counter.patient}</td>
                                                    <td>{counter.default_invoice_print_format}</td>
                                                    <td>{counter.default_pos_customer}</td>
                                                    <td>{counter.default_tender}</td>
                                                    <td>{new Date(counter.created_at).toLocaleDateString()}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(counter.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(counter.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CounterList;
